import { API_URL } from '../../../app-config/constants';
import { get as g } from '../request';

const RESOURCE = `${API_URL}/users/relationship`;

get.operation = 'READ';
get.idFrom = 'ARGS';
export function get(idOfA, idOfB) {
    return g(`${RESOURCE}/${idOfA}/${idOfB}`);
}
